import { createAction } from "@reduxjs/toolkit";

export const getAddressesSuccess = createAction("addresses/getAddressesSuccess")
export const getRequest = createAction("addresses/getRequest")
export const getProvincesSuccess = createAction('addresses/getProvincesSuccess')
export const getDistrictsSuccess = createAction('addresses/getDistrictsSuccess')
